import * as yup from "yup";
import { validation } from "formUtils/validation";

export const validationSchema = yup.object().shape({
  name: validation.stringRequired,
  date: validation.dateRequiredNoPast,
  signature: validation.stringRequired,
});
